import { type Block } from 'interfaces/EnergyAudit.interface';
import { type FC } from 'react';

interface NumberedBlockListProps {
  blocks: Block[];
}

const NumberedBlockList: FC<NumberedBlockListProps> = ({ blocks }) => (
  <>
    {blocks.map((block: Block, idx: number) => (
      <div key={idx} className="mb-4 text-gray-50">
        <div className="flex items-start font-bold">
          <span className="font-bold mr-2">{block.content.number}.</span>
          <span>{block.content.text}</span>
        </div>
        {block.content.bullets && Array.isArray(block.content.bullets) && (
          <ul className="list-disc pl-8 mt-1">
            {block.content.bullets.map((b: string, i: number) => (
              <li key={i}>{b}</li>
            ))}
          </ul>
        )}
      </div>
    ))}
  </>
);

export default NumberedBlockList;
